import { WhatsAppConversationDataType } from "@packages/chat-sdk";
import { Store } from "./store";
export interface WhatsAppChatStoreType {
  selectedConversation?: WhatsAppConversationDataType;
  // 机器人列表
  robotOptions?: { label: string; value: string }[];
}

export const whatsappChatStore = new Store<WhatsAppChatStoreType>(() => ({
  selectedConversation: undefined,
  robotOptions: [],
}));
export const whatsappChatStoreActions = {
  setSelectedConversation(payload?: WhatsAppConversationDataType) {
    whatsappChatStore.set({
      selectedConversation: payload,
    });
  },
  setRobotOptions(payload: { label: string; value: string }[]) {
    whatsappChatStore.set({
      robotOptions: payload,
    });
  },
};
